import { Image } from 'expo-image';
import { LinearGradient } from 'expo-linear-gradient';
import { StyleSheet } from 'react-native';
import { YStack } from 'tamagui';

import { color } from '@/constants/tokens';

import PSButton from './ui/PSButton';
import PSText from './ui/PSText';

// Copy is hardwired — one pass, one pitch. `onPress` is the only seam: the
// SCREEN decides where "Know more" goes.

// expo-image isn't Tamagui, so no `$token` props; contain keeps the wordmark's
// 1024x242 ratio inside the box.
const LOGO = { width: 180, height: 44 };

export default function APProfilePageUpsellBanner({
  onPress,
}: {
  onPress: () => void;
}) {
  return (
    <YStack
      alignSelf="stretch"
      rounded="$base"
      overflow="hidden"
      p={'$space.lg'}
      gap={'$space.lg'}
    >
      {/* Brand → onyx, the same diagonal as [[MembershipCard]]. */}
      <LinearGradient
        colors={[color.brand, color.brandDark]}
        start={{ x: 0, y: 0 }}
        end={{ x: 1, y: 1 }}
        style={StyleSheet.absoluteFill}
      />

      <Image
        source={require('@/assets/images/access-pass-logo.png')}
        style={LOGO}
        contentFit="contain"
      />

      <YStack gap={'$space.sm'}>
        <PSText.Title color="$color.textWhite">
          Get a Backstage Pass to the City!
        </PSText.Title>
        <PSText.Body2 color="$color.textWhite">
          Members unlock this tier, plus priority access, secret menus, and
          previews across town.
        </PSText.Body2>
      </YStack>

      <PSButton title="Know more" onPress={onPress} fullWidth />
    </YStack>
  );
}
